<template>
  <div class="stock-page" :class="{ 'stock-page--modern': isModern }">
    <KTCodePreview v-bind:title="'Danh sách tồn kho'">
      <template v-slot:toolbar>
        <div class="row align-items-center">
          <b-button
            size="sm"
            variant="outline-secondary"
            class="ui-switch-btn mr-2"
            @click="toggleUiMode"
          >
            <i
              style="font-size: 1rem"
              :class="isModern ? 'fas fa-undo' : 'fas fa-magic'"
            ></i>
            <span class="font-weight-bolder">{{
              isModern ? 'Giao diện cũ' : 'Giao diện mới'
            }}</span>
          </b-button>
          <b-dropdown size="sm" right>
            <template v-slot:button-content>
              <i style="font-size: 1rem" class="fas fa-cog"></i>
              <span class="font-weight-bolder">Thao tác</span>
            </template>
            <b-dropdown-item @click="exportExcel">
              <span>
                <i style="font-size: 1rem" class="far fa-file-excel"></i>
                &nbsp; Xuất Excel</span
              >
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template v-slot:preview>
        <div class="filter-bar">
        <b-row class="mb-5">
          <b-col>
            <label v-if="isModern" class="filter-label">Tìm kiếm</label>
            <b-input
              size="sm"
              placeholder="Nhập tên, mã, mã vạch sản phẩm"
              v-model="searchProduct"
              append-icon="search"
              single-line
              hide-details
              class="input-style"
              v-on:keyup.enter="onFilter()"
            ></b-input>
          </b-col>
          <b-col>
            <label v-if="isModern" class="filter-label">Danh mục</label>
            <treeselect
              :options="filteredCateOptions"
              :multiple="true"
              :searchable="true"
              placeholder="Chọn danh mục sản phẩm"
              :match-keys="['id', 'label']"
              :clearable="true"
              :show-count="true"
              openDirection="bottom"
              v-model="selectedCategories"
            />
          </b-col>

          <b-col>
            <label v-if="isModern" class="filter-label">Thương hiệu</label>
            <BDropdownCustom
              v-model="selectedBrands"
              :options="filteredBrandOptions"
              :placeholder="'thương hiệu'"
              :matchKey="['name']"
              :searchable="true"
            />
          </b-col>
          <b-col>
            <label v-if="isModern" class="filter-label">Cửa hàng</label>
            <BDropdownCustom
              v-model="value"
              :options="filteredOptions"
              :placeholder="'cửa hàng'"
              :matchKey="['name']"
              :searchable="true"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-4">
            <label v-if="isModern" class="filter-label">Doanh nghiệp</label>
            <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedCompany"
              :options="listCompany"
              value-field="id"
              text-field="name"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled
                  >-- Doanh nghiệp --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col class="mb-4">
            <label v-if="isModern" class="filter-label">Loại sản phẩm</label>
            <div style="display: flex !important">
              <b-form-select
                size="sm"
                v-model="selectedProductType"
                :options="listProductType"
                value-field="id"
                text-field="name"
                class="col-md-8 select-style"
              ></b-form-select>
              <b-checkbox v-model="haveStock" class="mt-2 ml-2"
                >Có tồn</b-checkbox
              >
            </div>
          </b-col>
          <b-col>
            <b-checkbox
              v-model="byParent"
              :class="isModern ? 'mt-2 mt-modern-checkbox' : 'mt-2'"
              >Tồn theo SP cha</b-checkbox
            >
          </b-col>
          <b-col></b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col cols="auto" class="d-flex align-items-center">
            <b-button
              size="sm"
              variant="primary"
              style="font-weight: 600; width: 70px"
              @click="onFilter()"
              >Lọc</b-button
            >
            <a
              v-if="isModern"
              href="javascript:void(0)"
              class="clear-filter-link ml-3"
              @click="clearFilters()"
            >
              <i class="fas fa-times"></i> Xóa lọc
            </a>
          </b-col>
          <b-col class="d-flex d-inline justify-content-end flex-wrap align-items-center">
            <span
              class="mr-2 stock-legend-item"
              v-for="opt in visibleStockLegends"
              :key="opt.id"
            >
              <i :class="[isModern ? opt.icon : 'fas fa-circle', 'fa-sm', opt.colorClass]"></i>
              {{ opt.name }}
            </span>
            <b-dropdown
              no-caret
              size="sm"
              variant="secondary"
              v-b-tooltip.hover
              title="Hiển thị"
              right
            >
              <template v-slot:button-content>
                <i
                  class="flaticon2-settings"
                  style="font-size: 1rem; padding-right: 0px"
                >
                </i>
              </template>

              <b-dropdown-header id="dropdown-header-label">
                <strong>Hiển thị:</strong>
              </b-dropdown-header>

              <div class="dropdown-item bg-white text-body">
                <b-form-checkbox-group
                  v-model="settingTable.quantity"
                  :options="productStockQuantityDisplayOptions"
                  stacked
                  value-field="id"
                  text-field="name"
                ></b-form-checkbox-group>
              </div>

              <b-dropdown-divider />

              <b-dropdown-header id="dropdown-header-price-columns">
                <strong>Cột giá:</strong>
              </b-dropdown-header>

              <div class="dropdown-item bg-white text-body">
                <b-form-checkbox-group
                  v-model="selectedDisplayColumns"
                  :options="columnDisplayOptions"
                  stacked
                ></b-form-checkbox-group>
              </div>
            </b-dropdown>
          </b-col>
        </b-row>
        </div>

        <div id="scroll-table">
          <b-table
            :items="listData"
            :fields="displayFields"
            :small="true"
            :busy="isLoading"
            :bordered="!isModern"
            :borderless="isModern"
            hover
            no-local-sorting
            :sort-by="filters.sortBy"
            :sort-desc="filters.sortOrder === 'desc'"
            @sort-changed="onSortChanged"
          >
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="20"></vcl-table>
            </template>

            <template v-slot:cell(productName)="row">
              <div class="product-name-cell">
                <ProductImageSmall :src="row.item.productImageUrl" />
                <div class="product-name-text">
                  <p class="m-0" style="font-weight: 500">
                    {{ row.item.productName }}
                  </p>
                </div>
                <span
                  v-if="row.item.companyCode"
                  class="badge badge-pill"
                  :style="{
                    backgroundColor: getCompanyCodeColor(row.item.companyCode),
                    color: '#fff',
                  }"
                >
                  {{ row.item.companyCode }}
                </span>
              </div>
            </template>

            <template v-slot:cell(sellingPrice)="row">
              <div style="text-align: end">
                <span v-text="formatPrice(row.item.sellingPrice)"></span>
              </div>
            </template>
            <template v-slot:cell(originalPrice)="row">
              <div style="text-align: end">
                <span
                  v-if="row.item.originalPrice != null"
                  v-text="formatPrice(row.item.originalPrice)"
                ></span>
                <i
                  v-else-if="!checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
                  class="fas fa-lock text-muted"
                  v-b-tooltip.hover
                  title="Bạn không có quyền xem giá nhập"
                ></i>
                <span v-else>—</span>
              </div>
            </template>
            <template v-slot:cell(totalQuantityInStock)="row">
              <div style="text-align: end">
                <span
                  v-if="
                    settingTable.quantity.includes(1) &&
                    row.item.totalQuantityInStock
                  "
                  class="mr-1"
                  v-b-tooltip.hover.bottom
                  title="Tổng tồn có thể bán"
                >
                  <i class="fas fa-check-circle fa-xs icon instock-color"></i>
                  <b v-text="row.item.totalQuantityInStock" class="text-dark"></b>
                </span>
                <span
                  class="mr-1"
                  v-if="
                    settingTable.quantity.includes(2) &&
                    row.item.totalQuantityTranfer
                  "
                  v-b-tooltip.hover.bottom
                  title="Tổng đang chuyển kho"
                >
                  <i class="fas fa-exchange-alt fa-xs icon text-primary"></i>
                  <b class="text-primary font-size-setting">{{
                    '+' + row.item.totalQuantityTranfer
                  }}</b>
                </span>
                <span
                  class="mr-1"
                  v-if="
                    settingTable.quantity.includes(3) &&
                    row.item.totalQuantityHolding
                  "
                  v-b-tooltip.hover.bottom
                  title="Tổng đang giữ hàng"
                >
                  <i class="fas fa-hand-paper fa-xs icon holding-color"></i>
                  <b class="holding-color font-size-setting">{{
                    '+' + row.item.totalQuantityHolding
                  }}</b>
                </span>
                <span
                  class="mr-1"
                  v-if="
                    settingTable.quantity.includes(4) &&
                    row.item.totalQuantityDelivery
                  "
                  v-b-tooltip.hover.bottom
                  title="Tổng đang vận chuyển"
                >
                  <i class="fas fa-truck fa-xs icon delivery-color"></i>
                  <b class="delivery-color font-size-setting">{{
                    '+' + row.item.totalQuantityDelivery
                  }}</b>
                </span>
                <span
                  class="mr-1"
                  v-if="
                    settingTable.quantity.includes(5) &&
                    row.item.totalQuantityWarranty
                  "
                  v-b-tooltip.hover.bottom
                  title="Tổng đang bảo hành"
                >
                  <i class="fas fa-wrench fa-xs icon warranty-color"></i>
                  <b class="warranty-color font-size-setting">{{
                    '+' + row.item.totalQuantityWarranty
                  }}</b>
                </span>
                <span
                  class="mr-1"
                  v-if="
                    settingTable.quantity.includes(6) &&
                    row.item.totalQuantityError
                  "
                  v-b-tooltip.hover.bottom
                  title="Tổng đang lỗi"
                >
                  <i class="fas fa-exclamation-circle fa-xs icon error-color"></i>
                  <b class="error-color font-size-setting">{{
                    '+' + row.item.totalQuantityError
                  }}</b>
                </span>
                <span
                  class="mr-1"
                  v-if="
                    settingTable.quantity.includes(7) &&
                    row.item.totalQuantityLending
                  "
                  v-b-tooltip.hover.bottom
                  title="Tổng đang cho mượn"
                >
                  <i class="fas fa-handshake fa-xs icon lending-color"></i>
                  <b class="lending-color font-size-setting">{{
                    '+' + row.item.totalQuantityLending
                  }}</b>
                </span>
              </div>
            </template>
            <template #cell()="data">
              <div v-html="data.value"></div>
            </template>

            <template slot="bottom-row">
              <td
                v-for="field in displayFields"
                :key="field.key"
                :style="getTotalCellStyle(field.key)"
              >
                <div
                  v-if="
                    getTotalValue(field.key) !== null &&
                    (field.key === 'totalQuantityInStock' ||
                      storeFields.some((f) => f.key === field.key))
                  "
                  style="text-align: end"
                  v-html="getTotalValue(field.key)"
                ></div>
                <span
                  v-else-if="getTotalValue(field.key) !== null"
                  v-html="getTotalValue(field.key)"
                ></span>
              </td>
            </template>
          </b-table>
        </div>
        <div class="bill-list-toolbar stock-list-toolbar">
          <div class="bill-list-toolbar__left">
            <span class="bill-list-toolbar__total">
              <span class="bill-list-toolbar__total-label">Tổng số:</span>
              <span class="bill-list-toolbar__total-value">{{ formatPrice(totalItem) }}</span>
            </span>
          </div>
          <div class="bill-list-toolbar__right">
            <BillRowsPerPageSelector
              v-model="pageSize"
              :options="stockPageSizeOptions"
              :disabled="isLoading"
              @change="onPageSizeChange"
            />
            <div v-show="numberOfPage >= 2" class="bill-list-toolbar__divider"></div>
            <b-pagination-nav
              v-show="numberOfPage >= 2"
              pills
              size="sm"
              :number-of-pages="numberOfPage || 1"
              :link-gen="paginationLinkGen"
              align="right"
              v-model="currentPage"
              use-router
              @change="onPaginationChange"
              class="bill-list-pagination"
            />
          </div>
        </div>
      </template>
    </KTCodePreview>
    <ProductStockExcel :param="excelParams" />
  </div>
</template>

<style scoped>
.d-flex {
  display: -webkit-box !important;
}
</style>
<style lang="scss" scoped>
.stock-page {
  &,
  * {
    box-sizing: border-box;
  }

  // Cho card-body một grid track có chiều rộng "definite" (minmax(0, 1fr)).
  // Nếu không, #scroll-table với width/max-width: 100% sẽ resolve theo
  // intrinsic content -> chiều rộng table tràn ngược lên toàn bộ layout,
  // khiến overflow-x: auto không bao giờ kích hoạt.
  ::v-deep .card-body {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }

  .filter-bar {
    max-width: 1280px;
  }

  .input-style {
    border: 1px solid #ced4da;
  }

  .checkbox-item {
    position: absolute;
    right: 1vw;
  }

  .checkbox-label {
    display: block;
  }

  #scroll-table {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    max-height: calc(100vh - 250px);
    -webkit-overflow-scrolling: touch;
    position: relative;
    box-sizing: border-box;
    // Ensure it doesn't exceed parent width
    min-width: 0;
  }

  #scroll-table ::v-deep .table-responsive {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  #scroll-table ::v-deep .b-table {
    width: 100% !important;
    max-width: 100% !important;
    display: table !important;
    overflow-x: auto !important;
    overflow-y: visible !important;
  }

  #scroll-table ::v-deep table {
    margin: 0;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
    width: auto;
    min-width: 100%;
    display: table;

    thead {
      position: sticky;
      top: 0;
      z-index: 10;
      background-color: white;
    }

    td {
      vertical-align: middle;
      padding: 0.25rem;
      overflow: visible !important;
      position: relative;
    }

    th {
      position: sticky;
      top: 0;
      z-index: 10;
      background-color: white !important;
      box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
      vertical-align: middle;
      padding: 0.25rem;
      overflow: visible !important;
    }

    tr {
      position: relative;
      z-index: 0;
    }

    th:first-child {
      position: sticky !important;
      left: 0;
      top: 0;
      z-index: 12;
      background-color: white !important;
      box-shadow: 2px 2px 2px -1px rgba(0, 0, 0, 0.1);
    }
    th:nth-child(2) {
      position: sticky !important;
      left: 400px;
      top: 0;
      z-index: 12;
      background-color: white !important;
      box-shadow: 2px 2px 2px -1px rgba(0, 0, 0, 0.1);
    }

    td:first-child {
      position: sticky;
      left: 0;
      z-index: 1;
      background-color: white;
      box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.1);
    }

    td:nth-child(2) {
      position: sticky;
      left: 400px;
      z-index: 1;
      background-color: white;
      box-shadow: 2px 0 4px -2px rgba(0, 0, 0, 0.1);
    }

    .font-size-setting {
      font-size: 0.86rem;
    }
  }
  .labelInput {
    font-weight: 600;
  }
  .productCode:hover {
    text-decoration: underline;
  }

  .inputText {
    width: 22%;
  }
  .btn.btn-icon.btn-sm,
  .btn-group-sm > .btn.btn-icon {
    height: calc(1.35em + 1.1rem + 2px);
    width: auto;
  }
  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .productNameClass {
    width: 40%;
  }
  .dropdown-header {
    color: #3699ff !important;
  }

  .warranty-color {
    color: #452bee !important;
  }

  .error-color {
    color: #dc3545 !important; // Đỏ đậm cho đang lỗi
  }

  .delivery-color {
    color: #6c757d !important; // Xám đậm cho đang vận chuyển
  }

  .holding-color {
    color: #fd7e14 !important; // Cam đậm cho đang giữ hàng
  }

  .lending-color {
    color: #ffc107 !important; // Vàng cho đang cho mượn
  }

  .instock-color {
    color: #212529 !important; // Mặc định (classic) — như text-dark cũ
  }

  // Icon theo loại tồn trong ô số: ẩn ở giao diện cũ, chỉ hiện ở modern
  ::v-deep .icon {
    display: none;
    margin-right: 2px;
  }

  .product-name-cell {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 4px 0;
    position: relative;
    z-index: 1;
    overflow: visible;
    isolation: isolate;
  }

  .product-name-text {
    flex: 1;
    min-width: 0;
  }

  .product-name-text p {
    line-height: 1.4;
    color: #212529;
  }

  // Đảm bảo tất cả cells không che ảnh zoom
  #scroll-table ::v-deep table td {
    overflow: visible !important;
  }

  // Đảm bảo sticky cells không che ảnh zoom
  #scroll-table ::v-deep table td:first-child,
  #scroll-table ::v-deep table td:nth-child(2) {
    overflow: visible !important;
  }

  .product-name-cell .badge {
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.35rem 0.65rem;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
  }

  .product-name-cell .badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
  }

  .stock-list-toolbar {
    padding-top: 12px;
    margin-top: 4px;
    margin-bottom: 0;
  }

  .bill-list-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    margin-bottom: 4px;
  }

  .bill-list-toolbar__left {
    display: flex;
    align-items: center;
  }

  .bill-list-toolbar__total {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
  }

  .bill-list-toolbar__total-label {
    font-size: 13px;
    font-weight: 450;
    color: #64748b;
  }

  .bill-list-toolbar__total-value {
    font-size: 15px;
    font-weight: 600;
    color: #1e293b;
    font-variant-numeric: tabular-nums;
  }

  .bill-list-toolbar__right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .bill-list-toolbar__divider {
    width: 1px;
    height: 20px;
    background: #e2e8f0;
  }

  ::v-deep .bill-list-pagination {
    margin-bottom: 0 !important;
  }

  ::v-deep .bill-list-pagination .pagination {
    margin-bottom: 0 !important;
  }

  ::v-deep .bill-list-pagination .page-link {
    border-radius: 6px !important;
  }
}

/* ===== Modern UI (thử nghiệm) — chỉ áp khi có class .stock-page--modern ===== */
.ui-switch-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
}

.stock-page--modern {
  .filter-bar {
    max-width: 100%;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 20px 20px 12px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    margin-bottom: 16px;
  }

  .filter-label {
    display: block;
    margin-bottom: 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #64748b;
  }

  .mt-modern-checkbox {
    margin-top: 2.1rem !important;
  }

  /* Inputs & selects: đồng bộ chiều cao, bo góc, viền nhạt */
  .input-style,
  ::v-deep .select-style,
  ::v-deep .vue-treeselect__control,
  ::v-deep .b-dropdown-custom-root .dropdown-toggle {
    min-height: 38px;
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px !important;
    box-shadow: none !important;
  }

  .input-style:focus,
  ::v-deep .select-style:focus,
  ::v-deep .vue-treeselect__control--focused {
    border-color: #3699ff !important;
    box-shadow: 0 0 0 3px rgba(54, 153, 255, 0.12) !important;
  }

  ::v-deep .vue-treeselect__control {
    display: flex;
    align-items: center;
  }

  .clear-filter-link {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
    white-space: nowrap;

    &:hover {
      color: #dc3545;
      text-decoration: none;
    }

    i {
      font-size: 11px;
    }
  }

  /* Hiện icon theo loại tồn trong ô số (ở giao diện cũ icon bị ẩn) */
  ::v-deep .icon {
    display: inline-block;
  }

  /* Legend: dạng "chip" gọn cho dễ đọc */
  .stock-legend-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #475569;
    margin-bottom: 4px;

    .instock-color {
      color: #21a366 !important;
    }
  }

  /* Bảng: header steel-blue chữ trắng, sọc xen kẽ dòng chẵn/lẻ */
  #scroll-table ::v-deep table {
    th {
      background-color: #1c6ea4 !important;
      color: #ffffff;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.4px;
      text-transform: uppercase;
      border: 0 !important;
      border-right: 1px solid rgba(255, 255, 255, 0.12) !important;
      padding: 0.85rem 0.6rem;
    }

    /* Ô header có thStyle color inline (rgb(24,28,50)) — ép trắng cho dễ đọc */
    th,
    th[style] {
      color: #ffffff !important;
    }

    th:first-child,
    th:nth-child(2) {
      background-color: #1c6ea4 !important;
    }

    /* Mũi tên sort của bootstrap-vue (background-image) màu trắng hơn */
    th[aria-sort] {
      opacity: 1;
    }

    td {
      padding: 0.6rem 0.6rem;
      border: 0 !important;
      border-bottom: 1px solid #eef2f7 !important;
      color: #1e293b;
      vertical-align: middle;
    }

    /* Zebra striping — áp cả 2 cột sticky để không trắng lệch khi cuộn ngang */
    tbody tr:nth-child(odd) td,
    tbody tr:nth-child(odd) td:first-child,
    tbody tr:nth-child(odd) td:nth-child(2) {
      background-color: #ffffff;
    }

    tbody tr:nth-child(even) td,
    tbody tr:nth-child(even) td:first-child,
    tbody tr:nth-child(even) td:nth-child(2) {
      background-color: #f6f8fb;
    }

    tbody tr:hover td,
    tbody tr:hover td:first-child,
    tbody tr:hover td:nth-child(2) {
      background-color: #eaf2fb;
    }

    /* Số tồn "có thể bán" + icon hiển thị màu xanh lá (Sẵn sàng bán) */
    td b.text-dark,
    td .instock-color {
      color: #21a366 !important;
    }

    /* Hàng tổng nổi bật — đặt sau zebra để thắng specificity, áp cả cột sticky */
    tbody tr:last-child td,
    tbody tr:last-child td:first-child,
    tbody tr:last-child td:nth-child(2) {
      background-color: #eef4fb;
      border-top: 2px solid #cfe0f0 !important;
      font-weight: 600;
    }
  }
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import localData from '@/utils/saveDataToLocal';
import { VclTable } from 'vue-content-loading';
import {
  convertPrice as commonConvertPrice,
  getCompanyCodeColor,
} from '@/utils/common';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ProductStockExcel from '../../components/product-stock/ProductStockExcel.vue';
import BillRowsPerPageSelector from '@/view/components/bills/BillRowsPerPageSelector.vue';
import ProductImageSmall from '@/view/components/products/ProductImageSmall.vue';
import useProductStockList, {
  PRODUCT_STOCK_PAGE_SIZE_OPTIONS,
} from '@/composables/useProductStockList';
import useProductFilters from '@/composables/useProductFilters';
import useStoreSelector from '@/composables/useStoreSelector';
import { PRODUCT_STOCK_QUANTITY_DISPLAY_OPTIONS } from './productStockQuantityDisplay';

const PRODUCT_STOCK_LIST_DISPLAY_COLUMNS_STORAGE_KEY =
  'product-stock-list-display-columns';

export default {
  components: {
    KTCodePreview,
    VclTable,
    BDropdownCustom,
    ProductStockExcel,
    BillRowsPerPageSelector,
    ProductImageSmall,
    Treeselect,
  },

  data() {
    const productStockList = useProductStockList();
    const productFilters = useProductFilters();
    const storeSelector = useStoreSelector();

    return {
      listData: productStockList.listData,
      grandTotals: productStockList.grandTotals,
      totalItem: productStockList.totalItem,
      numberOfPage: productStockList.numberOfPage,
      isLoading: productStockList.isLoading,
      fields: productStockList.fields,
      filters: productStockList.filters,
      settingTable: productStockList.settingTable,

      cateOptions: productFilters.cateOptions,
      filteredCateOptions: [],
      brandOptions: productFilters.brandOptions,
      filteredBrandOptions: productFilters.filteredBrandOptions,

      optionStores: storeSelector.optionStores,
      filteredOptions: storeSelector.filteredOptions,

      excelParams: null,
      listProductType: [
        { id: null, name: 'Tất cả' },
        { id: 1, name: 'Sản phẩm' },
        { id: 2, name: 'Sản phẩm theo IMEI' },
      ],

      searchProduct: '',
      selectedCategories: [],
      selectedBrandName: '',
      selectedBrands: [],
      selectedProductType: null,
      haveStock: true,
      productStockQuantityDisplayOptions: PRODUCT_STOCK_QUANTITY_DISPLAY_OPTIONS,
      byParent: false,
      value: [],
      currentPage: 1,
      pageSize: 30,
      stockPageSizeOptions: PRODUCT_STOCK_PAGE_SIZE_OPTIONS.map((size) => ({
        value: size,
        text: String(size),
      })),

      productStockListRef: productStockList,
      productFiltersRef: productFilters,
      storeSelectorRef: storeSelector,
      selectedCompany: null,
      listCompany: [],

      uiMode:
        localStorage.getItem('productStock_uiMode') === 'classic'
          ? 'classic'
          : 'modern',

      selectedDisplayColumns: [],
      columnDisplayOptions: [
        { text: 'Giá bán', value: 'sellingPrice' },
        { text: 'Giá nhập', value: 'originalPrice' },
      ],
    };
  },

  watch: {
    selectedDisplayColumns(newVal) {
      this.saveDisplayColumns(newVal);
    },
    searchProduct(newVal) {
      this.filters.searchProduct = newVal;
    },
    selectedCategories(newVal) {
      // selectedCategories là array, API có thể nhận array hoặc null
      this.filters.selectedCateId = newVal && newVal.length > 0 ? newVal : null;
    },
    selectedBrandName(newVal) {
      this.filters.selectedBrandName = newVal;
    },
    selectedBrands(newVal) {
      this.filters.selectedBrands = newVal;
    },
    selectedProductType(newVal) {
      this.filters.selectedProductType = newVal;
    },
    haveStock(newVal) {
      this.filters.haveStock = newVal;
    },
    byParent(newVal) {
      this.filters.byParent = newVal;
    },
    value(newVal) {
      this.filters.value = newVal;
    },
    currentPage(newVal) {
      this.filters.page = newVal;
    },
    selectedCompany(newVal) {
      this.filters.selectedCompany = newVal;
    },
    pageSize(newVal) {
      this.filters.limit = newVal;
    },
  },

  computed: {
    isModern() {
      return this.uiMode === 'modern';
    },
    visibleStockLegends() {
      return this.productStockQuantityDisplayOptions.filter((opt) =>
        this.settingTable.quantity.includes(opt.id),
      );
    },
    serverTotals() {
      return this.grandTotals || null;
    },
    totalSellingPrice() {
      return this.listData.reduce((sum, item) => {
        return sum + (item.sellingPrice || 0);
      }, 0);
    },
    totalQuantityInStock() {
      if (this.serverTotals) {
        return this.serverTotals.totalQuantityInStock || 0;
      }
      return this.listData.reduce((sum, item) => {
        return sum + (item.totalQuantityInStock || 0);
      }, 0);
    },
    totalQuantityTranfer() {
      if (this.serverTotals) {
        return this.serverTotals.totalQuantityTranfer || 0;
      }
      return this.listData.reduce((sum, item) => {
        return sum + (item.totalQuantityTranfer || 0);
      }, 0);
    },
    totalQuantityHolding() {
      if (this.serverTotals) {
        return this.serverTotals.totalQuantityHolding || 0;
      }
      return this.listData.reduce((sum, item) => {
        return sum + (item.totalQuantityHolding || 0);
      }, 0);
    },
    totalQuantityDelivery() {
      if (this.serverTotals) {
        return this.serverTotals.totalQuantityDelivery || 0;
      }
      return this.listData.reduce((sum, item) => {
        return sum + (item.totalQuantityDelivery || 0);
      }, 0);
    },
    totalQuantityWarranty() {
      if (this.serverTotals) {
        return this.serverTotals.totalQuantityWarranty || 0;
      }
      return this.listData.reduce((sum, item) => {
        return sum + (item.totalQuantityWarranty || 0);
      }, 0);
    },
    totalQuantityError() {
      if (this.serverTotals) {
        return this.serverTotals.totalQuantityError || 0;
      }
      return this.listData.reduce((sum, item) => {
        return sum + (item.totalQuantityError || 0);
      }, 0);
    },
    totalQuantityLending() {
      if (this.serverTotals) {
        return this.serverTotals.totalQuantityLending || 0;
      }
      return this.listData.reduce((sum, item) => {
        return sum + (item.totalQuantityLending || 0);
      }, 0);
    },
    storeFields() {
      // Get only store fields (fields that have numeric keys, which are store IDs)
      return this.fields.filter((field) => {
        const key = field.key;
        return (
          key &&
          key !== 'productName' &&
          key !== 'productCode' &&
          key !== 'sellingPrice' &&
          key !== 'originalPrice' &&
          key !== 'totalQuantityInStock'
        );
      });
    },
    displayFields() {
      const fixedKeys = ['productName', 'productCode', 'totalQuantityInStock'];
      const storeKeys = this.storeFields.map((field) => field.key);
      const visibleKeys = new Set([
        ...fixedKeys,
        ...storeKeys,
        ...this.selectedDisplayColumns,
      ]);
      return this.fields.filter((field) => visibleKeys.has(field.key));
    },
  },

  created() {
    const imeiCode = this.$route.query.code;
    const searchProduct = this.$route.query.searchProduct;
    const storeId = this.$route.query.storeId;
    const page = this.$route.query.page;

    if (imeiCode !== undefined) {
      this.filters.search = imeiCode;
    }
    if (searchProduct !== undefined) {
      this.searchProduct = searchProduct;
      this.filters.searchProduct = searchProduct;
    }
    if (storeId !== undefined) {
      this.filters.selectedStore = storeId;
    }
    if (page !== undefined) {
      this.currentPage = parseInt(page) || 1;
    }

    this.fields = this.productStockListRef.initializeFields();
    this.restoreDisplayColumns();
    this.checkViewOriginalPrice();
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Tồn kho', route: '/productStock' },
      { title: 'Danh sách tồn kho' },
    ]);

    // Đóng sidebar khi vào trang
    if (document.body.classList.contains('aside-minimize-hover')) {
      document.body.classList.remove('aside-minimize-hover');
    }
    if (!document.body.classList.contains('aside-minimize')) {
      document.body.classList.add('aside-minimize');
    }

    this.storeSelectorRef.fetchStores();
    this.fetchCategory();
    this.productFiltersRef.fetchBrands();
    this.productStockListRef.fetchStoreFields();
    this.productStockListRef.fetchData();
    this.fetchCompany();
  },

  methods: {
    checkPermission(condition) {
      return localData.checkPermission(condition);
    },

    restoreDisplayColumns() {
      const availableColumnValues = new Set(
        this.columnDisplayOptions.map((item) => item.value),
      );
      const defaultColumns = this.selectedDisplayColumns.filter((column) =>
        availableColumnValues.has(column),
      );
      try {
        const savedColumnsRaw = localStorage.getItem(
          PRODUCT_STOCK_LIST_DISPLAY_COLUMNS_STORAGE_KEY,
        );
        if (!savedColumnsRaw) {
          this.selectedDisplayColumns = defaultColumns;
          return;
        }

        const savedColumns = JSON.parse(savedColumnsRaw);
        if (!Array.isArray(savedColumns)) {
          this.selectedDisplayColumns = defaultColumns;
          return;
        }

        const validColumns = savedColumns.filter((column) =>
          availableColumnValues.has(column),
        );
        this.selectedDisplayColumns = validColumns.length
          ? validColumns
          : defaultColumns;
      } catch (error) {
        this.selectedDisplayColumns = defaultColumns;
      }
    },

    saveDisplayColumns(columns) {
      try {
        localStorage.setItem(
          PRODUCT_STOCK_LIST_DISPLAY_COLUMNS_STORAGE_KEY,
          JSON.stringify(columns),
        );
      } catch (error) {
        // Ignore localStorage errors (private mode, storage full, ...)
      }
    },

    checkViewOriginalPrice() {
      if (!this.checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')) {
        this.columnDisplayOptions = this.columnDisplayOptions.filter(
          (item) => item.value !== 'originalPrice',
        );
        this.selectedDisplayColumns = this.selectedDisplayColumns.filter(
          (item) => item !== 'originalPrice',
        );
      }
    },

    toggleUiMode() {
      this.uiMode = this.uiMode === 'modern' ? 'classic' : 'modern';
      localStorage.setItem('productStock_uiMode', this.uiMode);
    },

    clearFilters() {
      this.searchProduct = '';
      this.selectedCategories = [];
      this.selectedBrands = [];
      this.value = [];
      this.selectedCompany = null;
      this.selectedProductType = null;
      this.haveStock = true;
      this.byParent = false;
      this.onFilter();
    },

    formatPrice(value) {
      return commonConvertPrice(value);
    },

    exportExcel() {
      this.excelParams = this.productStockListRef.getParamFilters();
      this.$bvModal.show('product-stock-excel');
    },


    onFilter() {
      this.$route.query.page = 1;
      this.$router.push({
        name: 'list-product-stock',
      });
      this.productStockListRef.fetchStoreFields();
      this.productStockListRef.fetchData();
    },

    onSelectStore(option) {
      this.storeSelectorRef.onSelectStore(option);
    },

    onRemoveStore(option) {
      this.storeSelectorRef.onRemoveStore(option);
    },

    onPageChange(page) {
      this.currentPage = page;
      this.filters.page = page;
      this.productStockListRef.fetchData();
    },

    onPaginationChange(page) {
      this.onPageChange(page);
    },

    paginationLinkGen(pageNum) {
      const query = { ...this.$route.query };
      if (pageNum === 1) {
        delete query.page;
      } else {
        query.page = pageNum;
      }
      return {
        name: 'list-product-stock',
        query,
      };
    },

    onPageSizeChange() {
      this.currentPage = 1;
      this.filters.page = 1;
      this.filters.limit = this.pageSize;
      this.productStockListRef.fetchData();
    },

    onSortChanged(ctx) {
      this.filters.sortBy = ctx.sortBy != null ? String(ctx.sortBy) : null;
      this.filters.sortOrder = ctx.sortDesc ? 'desc' : 'asc';
      this.currentPage = 1;
      this.filters.page = 1;
      this.productStockListRef.fetchData();
    },
    getCompanyCodeColor,

    getStoreTotal(storeId) {
      const serverStoreTotals = this.serverTotals?.stores?.[storeId];
      if (serverStoreTotals) {
        return {
          quantityInStock: serverStoreTotals.quantityInStock || 0,
          transferInStock: serverStoreTotals.transferInStock || 0,
          holdingInStock: serverStoreTotals.holdingInStock || 0,
          deliveryInStock: serverStoreTotals.deliveryInStock || 0,
          warrantyInStock: serverStoreTotals.warrantyInStock || 0,
          errorInStock: serverStoreTotals.errorInStock || 0,
          lendingInStock: serverStoreTotals.lendingInStock || 0,
        };
      }

      return this.listData.reduce(
        (totals, item) => {
          const storeData = item[storeId];
          if (storeData && typeof storeData === 'object') {
            totals.quantityInStock += storeData.quantityInStock || 0;
            totals.transferInStock += storeData.transferInStock || 0;
            totals.holdingInStock += storeData.holdingInStock || 0;
            totals.deliveryInStock += storeData.deliveryInStock || 0;
            totals.warrantyInStock += storeData.warrantyInStock || 0;
            totals.errorInStock += storeData.errorInStock || 0;
            totals.lendingInStock += storeData.lendingInStock || 0;
          }
          return totals;
        },
        {
          quantityInStock: 0,
          transferInStock: 0,
          holdingInStock: 0,
          deliveryInStock: 0,
          warrantyInStock: 0,
          errorInStock: 0,
          lendingInStock: 0,
        },
      );
    },

    getTotalValue(fieldKey) {
      if (fieldKey === 'productName') {
        return 'Tổng';
      }
      if (fieldKey === 'productCode') {
        return '';
      }
      if (fieldKey === 'sellingPrice') {
        return null; // Không hiển thị tổng giá bán
      }
      if (fieldKey === 'totalQuantityInStock') {
        const haveShowBase = this.settingTable.quantity.includes(1);
        let html = '';
        if (this.totalQuantityInStock) {
          html = `<span class='mr-1 ${
            !haveShowBase ? 'd-none' : ''
          }' title='Tổng tồn có thể bán'><i class='fas fa-check-circle fa-xs icon instock-color'></i><b class='text-dark'>${
            this.totalQuantityInStock
          }</b></span>`;
        }

        if (this.totalQuantityTranfer) {
          const haveShow = this.settingTable.quantity.includes(2);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Tổng đang chuyển kho'><i class='fas fa-exchange-alt fa-xs icon text-primary'></i><b class='text-primary font-size-setting'>+${this.totalQuantityTranfer}</b></span>`;
        }

        if (this.totalQuantityHolding) {
          const haveShow = this.settingTable.quantity.includes(3);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Tổng đang giữ hàng'><i class='fas fa-hand-paper fa-xs icon holding-color'></i><b class='holding-color font-size-setting'>+${this.totalQuantityHolding}</b></span>`;
        }

        if (this.totalQuantityDelivery) {
          const haveShow = this.settingTable.quantity.includes(4);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Tổng đang vận chuyển'><i class='fas fa-truck fa-xs icon delivery-color'></i><b class='delivery-color font-size-setting'>+${this.totalQuantityDelivery}</b></span>`;
        }

        if (this.totalQuantityWarranty) {
          const haveShow = this.settingTable.quantity.includes(5);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Tổng đang bảo hành'><i class='fas fa-wrench fa-xs icon warranty-color'></i><b class='warranty-color font-size-setting'>+${this.totalQuantityWarranty}</b></span>`;
        }

        if (this.totalQuantityError) {
          const haveShow = this.settingTable.quantity.includes(6);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Tổng đang lỗi'><i class='fas fa-exclamation-circle fa-xs icon error-color'></i><b class='error-color font-size-setting'>+${this.totalQuantityError}</b></span>`;
        }

        if (this.totalQuantityLending) {
          const haveShow = this.settingTable.quantity.includes(7);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Tổng đang cho mượn'><i class='fas fa-handshake fa-xs icon lending-color'></i><b class='lending-color font-size-setting'>+${this.totalQuantityLending}</b></span>`;
        }

        return html;
      }
      if (fieldKey === 'originalPrice') {
        if (this.serverTotals && this.serverTotals.originalPrice != null) {
          return this.formatPrice(this.serverTotals.originalPrice);
        }
        const total = this.listData.reduce((sum, item) => {
          return sum + (item.originalPrice || 0);
        }, 0);
        return this.formatPrice(total);
      }
      // Store fields
      const isStoreField = this.storeFields.some((f) => f.key === fieldKey);
      if (isStoreField) {
        const totals = this.getStoreTotal(fieldKey);
        const haveShowBase = this.settingTable.quantity.includes(1);
        let html = '';
        if (totals.quantityInStock) {
          html = `<span class='mr-1 ${
            !haveShowBase ? 'd-none' : ''
          }' title='Tồn có thể bán'><i class='fas fa-check-circle fa-xs icon instock-color'></i><b class='text-dark'>${
            totals.quantityInStock
          }</b></span>`;
        }

        if (totals.transferInStock) {
          const haveShow = this.settingTable.quantity.includes(2);
          html += `<span class='prop-transfer mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Đang chuyển kho'><i class='fas fa-exchange-alt fa-xs icon text-primary'></i><b class='text-primary font-size-setting'>+${totals.transferInStock}</b></span>`;
        }

        if (totals.holdingInStock) {
          const haveShow = this.settingTable.quantity.includes(3);
          html += `<span class='prop-holding mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Đang giữ hàng'><i class='fas fa-hand-paper fa-xs icon holding-color'></i><b class='holding-color font-size-setting'>+${totals.holdingInStock}</b></span>`;
        }

        if (totals.deliveryInStock) {
          const haveShow = this.settingTable.quantity.includes(4);
          html += `<span class='prop-holding mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Đang vận chuyển'><i class='fas fa-truck fa-xs icon delivery-color'></i><b class='delivery-color font-size-setting'>+${totals.deliveryInStock}</b></span>`;
        }

        if (totals.warrantyInStock) {
          const haveShow = this.settingTable.quantity.includes(5);
          html += `<span class='prop-holding mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Đang bảo hành'><i class='fas fa-wrench fa-xs icon warranty-color'></i><b class='warranty-color font-size-setting'>+${totals.warrantyInStock}</b></span>`;
        }

        if (totals.errorInStock) {
          const haveShow = this.settingTable.quantity.includes(6);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Đang lỗi'><i class='fas fa-exclamation-circle fa-xs icon error-color'></i><b class='error-color font-size-setting'>+${totals.errorInStock}</b></span>`;
        }

        if (totals.lendingInStock) {
          const haveShow = this.settingTable.quantity.includes(7);
          html += `<span class='mr-1 ${
            !haveShow ? 'd-none' : ''
          }' title='Đang cho mượn'><i class='fas fa-handshake fa-xs icon lending-color'></i><b class='lending-color font-size-setting'>+${totals.lendingInStock}</b></span>`;
        }

        return html;
      }
      return '';
    },

    getTotalCellStyle(fieldKey) {
      const baseStyle = {
        fontWeight: '600',
      };

      if (fieldKey === 'productName') {
        return { ...baseStyle, textAlign: 'center' };
      }
      if (fieldKey === 'productCode') {
        return baseStyle;
      }
      if (fieldKey === 'sellingPrice') {
        return { ...baseStyle, textAlign: 'end' };
      }
      if (fieldKey === 'totalQuantityInStock') {
        return { ...baseStyle, textAlign: 'end' };
      }
      if (fieldKey === 'originalPrice') {
        return { ...baseStyle, textAlign: 'end' };
      }
      // Store fields
      const isStoreField = this.storeFields.some((f) => f.key === fieldKey);
      if (isStoreField) {
        return { ...baseStyle, textAlign: 'end' };
      }
      return baseStyle;
    },

    fetchCategory: function () {
      const param = {
        page: 1,
        limit: 1000,
        name: '',
        code: '',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('categories', paramQuery).then(({ data }) => {
        this.filteredCateOptions = data.data.list_caterogy;
      });
    },

    fetchCompany: async function () {
      this.listCompany = [];
      ApiService.get('/v1/companies/all').then((response) => {
        this.listCompany = response.data.data;
        this.listCompany.unshift({
          id: null,
          name: 'Tất cả',
        });
      });
    },
  },
};
</script>
